import { z } from 'zod';

export const dynamicRange = z.object({
  id: z.string(),
  customerId: z.string(),
  customerName: z.string(),
  traderSiteId: z.string(),
  traderSiteName: z.string(),
  materialId: z.string(),
  materialName: z.string(),
  materialAlterCodeId: z.string(),
  materialAlterCodeCode: z.string(),
  lastDocumentQuantity: z.number(),
  lastDocumentDate: z.string(),
});

export const getDynamicRangesWithConditionsSchema = z.array(dynamicRange);

export type GetDynamicRangesWithConditionsResponse = z.infer<
  typeof getDynamicRangesWithConditionsSchema
>;
